import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import COLOR_PALETTE from "constants/color-palette"

const InputLabel = ({
  textArea, dirty, text, required, disabled, styleName
}) => (
  <div
    data-test="input-label"
    style={[
      labelStyles.base({ textArea, styleName }),
      dirty ? labelStyles.dirty : labelStyles.clean,
      disabled ? labelStyles.disabled : {}
    ]}>
    {text}
    {required && <sup style={{ color: "#bf0000", fontWeight: "300" }}>*</sup>}
  </div>
)

InputLabel.propTypes = {
  textArea: PropTypes.bool, // To detect if the label is for textArea, then we move the label to top-left
  dirty: PropTypes.bool,
  required: PropTypes.bool,
  styleName: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool
}

InputLabel.defaultProps = {
  textArea: false,
  dirty: false,
  required: false,
  text: "",
  styleName: "light",
  disabled: false
}

const labelStyles = {
  base: ({ textArea, styleName }) => ({
    position: "absolute",
    bottom: textArea ? undefined : 0,
    top: textArea ? 0 : undefined,
    left: 0,
    padding: "0.25em 0 0.75em",
    fontWeight: 200,
    color: styleName === "light" ? COLOR_PALETTE.GRAY_DARK : COLOR_PALETTE.WHITE,
    transition: "transform .25s"
  }),
  clean: {
    pointerEvents: "none"
  },
  dirty: {
    fontSize: "80%",
    transform: "translateY(-100%)"
  },
  disabled: {
    opacity: 0.32,
    cursor: "not-allowed"
  }
}

export default Radium(InputLabel)



// WEBPACK FOOTER //
// ./src/components/form-elements/input-label/index.jsx